import DashboardForm from "../../components/views/dashboard";

function DashboardPage() {

  return <DashboardForm />
}

export default DashboardPage;
